import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { sel, todayIso } from "@/lib/finance";
import { formatDate } from "@/lib/format";
import { ActionBadge, ActivityTable } from "@/components/takip/ActivityTable";

const Card = ({ label, value, testid, tone = "text-slate-900" }) => (
  <div className="panel p-3 min-w-0"><div className="text-[11px] uppercase tracking-wider text-slate-500 truncate">{label}</div>
    <div className={`mt-1 font-semibold text-sm md:text-base break-words ${tone}`} data-testid={testid}>{value}</div></div>
);

export function UserTracking({ meta, uid, setUid }) {
  const [date, setDate] = useState(todayIso());
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!uid) return;
    setS(null); setErr("");
    api.get(`/takip/users/${uid}/summary`, { params: { date } }).then(({ data }) => setS(data)).catch((e) => setErr(apiError(e)));
  }, [uid, date]);
  return (
    <div className="space-y-3" data-testid="user-tracking">
      <div className="panel p-3 flex flex-wrap items-end gap-2">
        <label className="text-[11px] text-slate-500 flex flex-col gap-1">Kullanıcı<select className={`${sel} w-64 max-w-full`} value={uid} onChange={(e) => setUid(e.target.value)} data-testid="tracking-user-select">
          <option value="">Seçin…</option>{(meta?.users || []).map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}</select></label>
        <label className="text-[11px] text-slate-500 flex flex-col gap-1">Gün<Input type="date" className="h-9 w-40" value={date} onChange={(e) => setDate(e.target.value)} data-testid="tracking-date" /></label>
      </div>
      {!uid ? <div className="panel p-8 text-center text-sm text-slate-400">Takip etmek için bir kullanıcı seçin</div> : err ? <div className="panel p-4 text-rose-700 text-sm">{err}</div> : !s ? <div className="panel h-24 animate-pulse" /> : (<>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
          <Card label="İlk giriş" value={s.first_login ? formatDate(s.first_login) : "Bugün giriş yok"} testid="tracking-first-login" />
          <Card label="Son hareket" value={s.last_activity ? formatDate(s.last_activity) : "—"} testid="tracking-last-activity" />
          <Card label="Durum" value={s.online ? "Çevrimiçi" : "Çevrimdışı"} tone={s.online ? "text-emerald-700" : "text-slate-500"} testid="tracking-online" />
          <Card label="Oturum" value={s.session_count} testid="tracking-sessions" />
          <Card label="İşlem sayısı" value={s.action_count} testid="tracking-actions" />
        </div>
        <div className="grid gap-3 lg:grid-cols-2">
          <div className="panel p-3" data-testid="tracking-by-action"><div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-2">İşlem türleri</div>
            <div className="flex flex-wrap gap-2">{s.by_action.length ? s.by_action.map((r) => <span key={r.action} className="inline-flex items-center gap-1"><ActionBadge a={r.action} /><b className="text-xs">{r.count}</b></span>) : <span className="text-xs text-slate-400">Hareket yok</span>}</div></div>
          <div className="panel p-3" data-testid="tracking-pages"><div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-2">Ziyaret edilen sayfalar</div>
            {s.pages.length ? <ul className="space-y-1 max-h-40 overflow-y-auto">{s.pages.map((p) => <li key={p.route} className="flex justify-between gap-2 text-xs">
              <Link to={p.route} className="text-blue-700 hover:underline truncate">{p.title || p.route}</Link><span className="text-slate-400 whitespace-nowrap">{p.count}× · {formatDate(p.last)}</span></li>)}</ul>
              : <span className="text-xs text-slate-400">Sayfa görüntüleme yok</span>}</div>
        </div>
        <ActivityTable params={{ user_ids: uid, date_from: date, date_to: date }} showUser={false} />
      </>)}
    </div>
  );
}
